import React from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'

import { HEADER_HEIGHT } from '@app/ui/theme/constants'
import { notificationsSelector } from '@app/store/notifications'

import { NotificationsMessage } from './NotificationsMessage'

interface NotificationsContainerProps {
  className?: string
}

export const CONTAINER_CLASS_NAME = 'notifications-container'

const NotificationsWrapper = styled.div.attrs<NotificationsContainerProps>(() => ({
  className: CONTAINER_CLASS_NAME
}))<NotificationsContainerProps>`
  position: fixed;
  left: 0;
  right: 0;
  z-index: ${({ theme }) => theme.global.depth.overlay};
  top: ${HEADER_HEIGHT}rem;
`

export const NotificationsContainer = ({ className }: NotificationsContainerProps) => {
  const notifications = useSelector(notificationsSelector)

  if (!notifications.length) {
    return null
  }

  return (
    <NotificationsWrapper className={className}>
      {notifications.map(notification => (
        <NotificationsMessage
          id={notification.id}
          actionType={notification.actionType!}
          autoCloseTime={notification.autoCloseTime}
          key={notification.id}>
          {notification.message}
        </NotificationsMessage>
      ))}
    </NotificationsWrapper>
  )
}
